import React, { useState, useEffect } from "react";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import UploadMultiFile from "../../../components/GenericComponent/UploadMultiFile";
import ChiTietCuaHangApi from "../../../service/chiTietCuaHangApi";

export const ThuocTinhTaiSan2 = ({
  currentForm,
  datanew,
  update,
  AnhTaiSan,
  updateAnhTaiSan,
}) => {
  const { errors, register, control } = currentForm;
  const [imageTaiSans, setImageTaiSans] = useState([]);

  const [nameCode, setNameCode] = React.useState("");
  useEffect(() => {
    ChiTietCuaHangApi.chiTietCuaHangHienTai().then((response) => {
      setNameCode(response.data.Code);
    });
  }, []);

  // console.log(datanew);
  // const updateTextValue = (field) => (e) => {
  //   dispatch(
  //     themMoiTaiSan({
  //       ...dataAddAndEdit,
  //       [field]: e.target.value,
  //     })
  //   );
  // };
  //console.log(datanew.Options);

  const onChangeThuocTinhTaiSan = (configId) => (e) => {
    const newOptions = datanew.Options.map((item, index) => {
      if (index === configId) {
        return {
          ...item,
          OptionValue: e.target.value,
        };
      }
      return item;
    });
    update({
      ...datanew,
      Options: newOptions,
    });
    // thuocTinhTaiSan.OptionName = dataOptionLoaiTs[configId].OptionValue =
    //   e.target.value;
    // dataOptionLoaiTs[configId].OptionValue = e.target.value;
    // dataAddAndEdit.Options = dataOptionLoaiTs;
    // dispatch(themMoiTaiSan(dataAddAndEdit));
    //themMoiTaiSan(dataOptionLoaiTs);
  };

  // useEffect(() => {
  //   const AnhTaiSan = {
  //     AnhTaiSan: imageTaiSans.join(","),
  //   };
  //   setImageTaiSans(AnhTaiSan);
  // }, []);

  return (
    <>
      <div className="col-md-12 mt-1">
        <div className="row">
          <div className="col-md-12">
            <div className="card-header">
              <a className="card-title lead info collapsed">
                <h3>Thông tin tài sản</h3>
              </a>
            </div>
          </div>

          {datanew.Options &&
            datanew.Options.map((item, index) => (
              <div className="col-md-3" key={"Thuoctinhts1" + index}>
                <TextInputOnRow
                  labelClass="label-control color7-bold"
                  inputClass="form-control input-sm"
                  wrapperClass="form-group"
                  labelText={item.TenThuocTinh}
                  inputProps={{
                    ref: register,
                    name: "datanew[" + index + "].OptionValue",
                    onChange: onChangeThuocTinhTaiSan(index),
                    value: datanew.Options[index].OptionValue,
                  }}
                ></TextInputOnRow>
                <input
                  type="hidden"
                  name={"datanew[" + index + "].OptionName"}
                  value={item.MaThuocTinh}
                  ref={register}
                ></input>

                {/* <TextInputOnRow
                  labelClass="label-control"
                  inputClass="form-control input-sm"
                  wrapperClass="form-group"
                  labelText={item.TenThuocTinh}
                  inputProps={{
                    ref: register,
                    name:
                      "dataAddAndEdit.dataOptionLoaiTs[" +
                      index +
                      "].OptionValue",
                    onChange: onChangeThuocTinhTaiSan(index),
                    value: dataOptionLoaiTs[index].OptionValue,
                  }}
                ></TextInputOnRow> */}
                {/* <label>{item.TenThuocTinh}</label>
                <input
                  type="text"
                  name={item.MaThuocTinh}
                  onChange={onChangeThuocTinhTaiSan(
                    item.MaThuocTinh,
                    item.TenThuocTinh
                  )}
                  value={item.GiaTriThuocTinh}
                  ref={register}
                ></input> */}
              </div>
            ))}
        </div>
      </div>

      <div className="col-md-12 mt-1">
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <UploadMultiFile
                Files={AnhTaiSan}
                onChange={updateAnhTaiSan}
                Code={nameCode}
              ></UploadMultiFile>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
